// Inputmask for credova phone number
import Inputmask from "inputmask";

export function inputMaskCredova() {
    var im = new Inputmask("(999) 999-9999", {
        showMaskOnHover: false,
        showMaskOnFocus: false
    });
    var phoneCredova = document.getElementById("credova-mobile-phone");
    im.mask(phoneCredova);
}